import { SelectField } from '~/common/components';
import { useI18n, Trans } from '~/common/context';
import { IOptionItem } from '@wyz/types';
import { isNil } from 'lodash-es';
import { BrandTemplateHelpers } from '~/connect/helpers';
import { BRAND_EAN_SPECIFICATIONS } from '~/connect/schemas';
import { IBrandTemplate } from '~/connect/types';

export const SelectBrandEanConfiguration = ({
  name,
  onSelect,
}: {
  onSelect: (value: IBrandTemplate['brandEanSpecification']) => void;
  name: string;
}) => {
  const { t } = useI18n();

  const options: Array<IOptionItem<IBrandTemplate['brandEanSpecification']>> = [
    {
      label: t(
        BrandTemplateHelpers.BRAND_EAN_SPECIFICATIONS_LOOKUP[
          BRAND_EAN_SPECIFICATIONS.NO_SPECIFICATION
        ],
      ),
      value: BRAND_EAN_SPECIFICATIONS.NO_SPECIFICATION,
    },
    {
      label: t(
        BrandTemplateHelpers.BRAND_EAN_SPECIFICATIONS_LOOKUP[
          BRAND_EAN_SPECIFICATIONS.WYZ_REFERENTIAL
        ],
      ),
      value: BRAND_EAN_SPECIFICATIONS.WYZ_REFERENTIAL,
    },
    {
      label: t(
        BrandTemplateHelpers.BRAND_EAN_SPECIFICATIONS_LOOKUP[
          BRAND_EAN_SPECIFICATIONS.CONTRACT_NUMBER
        ],
      ),
      value: BRAND_EAN_SPECIFICATIONS.CONTRACT_NUMBER,
    },
  ];

  return (
    <SelectField<false, IOptionItem<IBrandTemplate['brandEanSpecification']>>
      name={name}
      label={
        <Trans i18nKey='app.brand_template.form.brand_ean_configuration.label' />
      }
      options={options}
      onSelect={(option) => {
        if (option && !isNil(option?.value)) onSelect(option.value);
      }}
    />
  );
};
